<script setup>
import { Select } from "flowbite-vue";
import { ref, watch, defineEmits, computed } from "vue";
import { useAuth0 } from "@auth0/auth0-vue";
import config from "@/config";
import { logEvent } from "@/api";

const emit = defineEmits(["update:boundaryType", "update:boundaryYear"]);
const options = [
  { label: "2024", value: "2024" },
  { label: "2021", value: "2021" },
  { label: "2018", value: "2018" },
  { label: "2021 ⇒ 2024", value: "2021,2024" },
  { label: "2018 ⇒ 2024", value: "2018,2024" },
  { label: "2018 ⇒ 2021", value: "2018,2021" },
];

const year = ref(config.firstYear);

watch(year, (newVal) => {
  emit("update:boundaryYear", newVal);
  logEvent("boundary-year-select", newVal);
});

window.eventBus.on("set-comparison-mode", (mode) => {
  if (mode === "single") {
    year.value = "2021"; // TODO reconsider
  }
});
</script>

<template lang="pug">
.year-selector
  w-select(v-model="year" :items="options" label="Year" no-unselect style="width:8em")

</template>
